var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('revenue-manager-setup-property-filter',{attrs:{"loading":_vm.loading},on:{"search":_vm.setFilter}}),_c('revenue-manager-setup-property-list',{attrs:{"filter":_vm.filter},on:{"busyToggled":_vm.toggleBusy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }